import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";
import ClientPreviewRequirementCard from "./ClientPreviewRequirementCard";
import { clientAddNewRequirement, clientDashboard } from "../common/allLinks";
import ClientRequirementLiveModal from "./ClientRequirementLiveModal";
import BreadcrumbMenu from "../common/BreadcrumbMenu";

export default function ClientDashboardPreviewRequirement() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="client-dashboard-preview-requirement-main-div mt-dashboard-agency-bg">
      <div className="custom-d-flex flex-nowrap justify-content-between align-items-center">
        <div>
          <BreadcrumbMenu
            menuObj={[
              {
                title: "Dashboard",
                link: clientDashboard,
              },
              {
                title: "Create New Requirement",
                type: "goBackButton",
              },
              {
                title: "Preview Listing",
              },
            ]}
          />
          <h4 className="font-24-NunitoSans-600">
            <Link to={clientDashboard}>
              <img
                src={"/img/desktop/icons/white-left-arrow-icon.svg"}
                alt="left-arrow"
                className="client-dashboard-add-new-requirement-left-arrow"
              />
            </Link>
            This is how your listing would appear
          </h4>
        </div>
        <div className="custom-d-flex mt-agency-req-details-buttons-block">
          <LinkBorderCommonButton
            extraClassName="login-btn-link--preview mr-30"
            linkText="Save &amp; Exit"
            linkPath={clientDashboard}
          />
          <LinkBorderCommonButton
            extraClassName="login-btn-link--preview mr-30"
            linkText="Make Changes"
            linkPath={clientAddNewRequirement}
          />
          <ClientRequirementLiveModal />
        </div>
      </div>
      <ClientPreviewRequirementCard />
    </div>
  );
}
